export default __webpack_public_path__ + "static/media/sign.7f965562.svg";